<template>
  <img class="unselect" @click="kktLogin" src="/static/icon/ic_kakao_circle.svg">
</template>

<script>
  export default {
    name: "BtnSigninKakao",
    methods: {
      kktLogin() {
        // test
        // const url = encodeURIComponent('http://localhost:8001/auth/user/signin/kakao/launchpack');
        const url = encodeURIComponent('https://master-dev.launchpack.co.kr:1111/auth/user/signin/kakao/launchpack');
        location.href = `https://kauth.kakao.com/oauth/authorize?client_id=294f3dbc51837f7026bcf882db270f56&redirect_uri=${url}&response_type=code`
      }
    }
  }
</script>

<style lang="stylus" scoped>
  img
    width 52px
    height 52px
</style>
